<template>
  <div class="object-select-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <select class="form-control" ref="dropdown"
        :name="options.name"
        @change="validate()">
          <template v-if="options.optgroup">
            <template v-for="object in options.objects">
              <optgroup :label="object.text">
                <option v-for="val in object.children"
                :value="val.uuid"
                :checked="val.uuid === value">{{ val[options.objectName] }}</option>
              </optgroup>
            </template>
          </template>
          <template v-else>
            <option v-for="object in options.objects"
            :value="object.uuid"
            :checked="object.uuid === value">{{ object[options.objectName] }}</option>
          </template>
        </select>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Choices from 'choices.js'
import _ from 'lodash'
import Api from '@/vuex/api'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'SmartcardSelectInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'object_select',
          objectName: 'fullName',
          value: '',
          objects: [],
          required: false
        }
      }
    }
  },
  data () {
    return {
      isDirty: false,
      isValid: false,
      choices: false,
      searching: false
    }
  },
  computed: {
    label () {
      return this.options.singleLabel
        ? this.options.singleLabel
        : this.options.label
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    let options = this.options
    function callbackOnCreateTemplates (template) {
      let classNames = this.config.classNames
      return {
        item: (data) => {
          let object = options.objects[data.id - 1]
          let label = data.label
          let closeButton = `
          <button class="${classNames.button}" data-button>Remove item</button>
          `
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          if (data.title) {
            label = `${data.label} ${data.title}`
          }
          if (this.config.removeItemButton) {
            label = `${label} ${closeButton}`
          }
          return template(`
          <div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : classNames.itemSelectable}"  data-item data-id="${data.id}" data-value="${data.value}" ${data.active ? 'aria-selected="true"' : ''} ${data.disabled ? 'aria-disabled="true"' : ''}>
            ${label}
          </div>
          `)
        },
        choice: (data) => {
          let object = options.objects[data.id - 1]
          let label = data.label
          if (data.id && object) {
            if (object[options.iconName]) {
              label = `<span class="fa fa-fw ${object[options.iconName]}"></span> ${data.label}`
            }
          }
          return template(`
          <div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : classNames.itemSelectable}" data-select-text="${this.config.itemSelectText}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}" ${data.groupId > 0 ? 'role="treeitem"' : 'role="option"'}>
            ${label}
          </div>
          `)
        }
      }
    }
    let $vm = this
    /* eslint-disable no-new */
    this.choices = new Choices(this.$refs.dropdown, {
      callbackOnCreateTemplates,
      removeItemButton: true,
      itemSelectText: '',
      noChoicesText: 'No cards matched your search... ',
      placeholder: true,
      placeholderValue: 'Search for a ' + this.label,
      searchPlaceholderValue: 'Search for a ' + this.label,
      searchChoices: false,
      searchResultLimit: 6,
      shouldSort: false
    })
    this.$refs.dropdown.addEventListener('search', async function ({ detail }) {
      if ($vm.searching) {
        $vm.searching.cancel()
        $vm.searching = false
      }
      $vm.searching = _.debounce(async (val) => {
        let instance = new Api()
        let results = await instance.searchSmartcard(detail.value)
        results.map(function (val, i) {
          results[i] = { value: val.uuid, label: val.dropdownLabel }
        })
        results.sort(function (a, b) {
          let searchA = a.label.match(new RegExp(detail.value, 'i')) || { index: -1 }
          let searchB = b.label.match(new RegExp(detail.value, 'i')) || { index: -1 }
          return searchA.index > searchB.index
        })
        results.reverse()
        $vm.choices.setChoices(results, 'value', 'label', true)
      }, 750, { 'leading': false, 'trailing': true })
      if (detail.value.length > 1) {
        $vm.searching(detail.value)
      }
    })
  },
  methods: {
    async validate (val) {
      await this.$nextTick()
      let data = false
      if (!val) {
        data = this.choices.getValue()
        val = data ? data.value : null
      }
      this.$emit('input', val)
      if (this.options.required) {
        this.isDirty = true
        this.isValid = val && val.length > 0
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/SmartcardSelectInput.vue